import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {
  containerStyles,
  imageContainerStyles,
  imagePreviewStyles,
  viewLargerButtonStyles,
  viewLargerButtonIconStyles,
} from './styles';
import Dialog from '@mui/material/Dialog';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import TimestampFooter from '../TimestampFooter';
import { useTheme } from '@mui/material/styles';
import ViewImage from './ViewImage';
import ZoomInIcon from '@mui/icons-material/ZoomIn';

const ImageBody = ({
  src,
  fileType,
  isOutgoing,
  message,
  /** Exposes an interface to cue the auto scroll hook to continue scrolling when the message's image has loaded  */
  emitImageLoaded,
}) => {
  const theme = useTheme();
  const [shouldDisplayFullImage, setShouldDisplayFullImage] = useState(false);

  return (
    <>
      <Dialog open={shouldDisplayFullImage}>
        <ViewImage
          src={src}
          fileType={fileType}
          onClose={() => setShouldDisplayFullImage(false)}
        />
      </Dialog>

      <Box sx={containerStyles}>
        <Box sx={imageContainerStyles}>
          <img
            onLoad={emitImageLoaded}
            style={imagePreviewStyles(isOutgoing, theme)}
            src={src}
            alt="Test"
          />
        </Box>

        <Button
          onClick={() => setShouldDisplayFullImage(true)}
          size="small"
          type="text"
          sx={viewLargerButtonStyles}
        >
          <ZoomInIcon sx={viewLargerButtonIconStyles} />
          View Larger
        </Button>

        <If condition={message.isLastMessageInParticipantBatch}>
          <TimestampFooter
            timestamp={DateTime.fromJSDate(message.timestamp).toLocaleString(
              DateTime.DATETIME_SHORT
            )}
          />
        </If>
      </Box>
    </>
  );
};

ImageBody.propTypes = {
  message: PropTypes.shape({
    isLastMessageInParticipantBatch: PropTypes.bool.isRequired,
    timestamp: PropTypes.instanceOf(Date).isRequired,
  }).isRequired,
  src: PropTypes.string.isRequired,
  fileType: PropTypes.string.isRequired, // MIME type string
  isOutgoing: PropTypes.bool.isRequired,
  emitImageLoaded: PropTypes.func.isRequired,
};

export default ImageBody;
